<template>
  <div class="change-password">
    <h3 class="def-title-3">
      <span class="change-password__title enter__active">{{
        obData.messages.change_password
      }}</span>
    </h3>

    <!--            Вывод системных ошибок восстановления пароля если существуют-->
    <div v-if="obData.authInfo.errors" class="change-password__errors">
      <span v-for="error in obData.authInfo.errors.system_errors">{{ error }}</span>
    </div>

    <form class="change-password__tab form-vertical" @submit.prevent="changePassword($event)">
      <DefInput
        v-for="input in obData.changePasswordInputs"
        :required="input.type !== 'hidden'"
        :placeholder="input.placeholder"
        :name="input.name"
        :type="input.type"
        :value="input.value"
        :disabled="input.disabled"
        :autocomplete="input.autocomplete"
      />
    </form>

    <!--        Форма реотправки кода на тел. для подтверждения регистрации-->
    <form @submit.prevent="resendPhoneCode($event)">
      <DefInput
        v-for="input in obData.resendPhoneCodeInputs"
        :required="input.type !== 'hidden'"
        :name="input.name"
        :type="input.type"
        :value="input.value"
      />
      <button
        type="submit"
        name="SEND_DATA"
        class="def-button-border"
        :class="{ 'hide-btn': count > 0 }"
        :disabled="count > 0"
      >
        {{ obData.messages.resend_phone_code }}
      </button>
    </form>

    <div v-if="count > 0" class="change-password__resend_message">
      <span>{{ obData.messages.phone_code_timer + count + ' сек' }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DefInput from '@components/Def/DefInput/DefInput.vue';

export default {
  name: 'ChangePassword',
  components: { DefInput },
  data() {
    return {
      count: '',
      resendTimer: '',
    };
  },

  mounted() {
    this.getComponentData();
  },
  methods: {
    async resendPhoneCode(e) {
      try {
        const data = new FormData(e.target);

        this.count = 60;
        const response = await axios.post(
          '/bitrix/services/main/ajax.php?action=main.phoneauth.resendCode',
          data
        );

        if (response.status === 200 || response.statusText === 'OK') {
          this.$store.commit('personal/updateData', {
            name: 'resendPhoneCodeData',
            data: response.data,
          });
          this.startResendPhoneCodeTimer();
        }
      } catch (err) {
        console.error(err);
      }
    },

    startResendPhoneCodeTimer() {
      let current = this.count;
      const to = 0;

      const go = () => {
        if (current > to) {
          this.resendTimer = setTimeout(go, 1000);
        }
        this.count = current;
        current--;
      };

      this.resendTimer = setTimeout(go, 1000);
    },

    async changePassword(e) {
      try {
        const data = new FormData(e.target);
        const path = this.obData?.actions?.change_password;
        const {
          data: { action, api },
        } = this.obData?.routes?.change_password;

        data.append('action', action);
        data.append('api', api);

        const response = await axios.post(path, data);

        if (response.status === 200) {
          this.$store.commit('personal/updateData', {
            name: 'authInfo',
            data: response.data.authInfo,
          });
          this.count = 60;
          clearTimeout(this.resendTimer);
          this.startResendPhoneCodeTimer();
        }

        if (response.data.authInfo.status) {
          location.reload();
        }
      } catch (err) {
        console.error(err);
      }
    },

    async getComponentData() {
      const {
        path,
        data: { action },
      } = this.obData?.routes?.change_password;
      const response = await axios.post(path, {
        api: 'y',
        action,
      });
      this.$store.commit('personal/updateData', {
        name: 'changePasswordInputs',
        data: response.data.changePasswordInputs,
      });
      this.$store.commit('personal/updateData', {
        name: 'resendPhoneCodeInputs',
        data: response.data.resendPhoneCodeInputs,
      });
      this.count = 60;
      this.startResendPhoneCodeTimer();
    },
  },

  computed: {
    ...mapState({
      obData: (state) => state.personal.data,
    }),
  },
};
</script>

<style lang="scss" scoped>
.change-password {
  max-width: 440px;
  background-color: #ffffff;
  padding: 40px 50px;
  height: 100vh;
  @include point-md {
    height: 100%;
  }

  &__errors {
    color: red;
  }

  &__nav {
    display: flex;
    border: 1px solid #f5f5f5;
    height: 40px;
    margin-bottom: 20px;

    & > div {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50%;
      pointer-events: auto;
      font-size: rem(14);
      @include point-md {
        font-size: rem(12);
      }
      @include point-lg {
        font-size: rem(14);
      }

      &:hover {
        cursor: pointer;
      }
    }

    .enter__active {
      background-color: #f5f5f5;
    }
  }

  .def-title-3 {
    font-size: rem(22);
    @include point-lg {
      font-size: rem(30);
    }

    & > *:not(.enter__active) {
      display: none;
    }
  }

  .def-button {
    margin-bottom: 17px;
    font-size: rem(14);
    @include point-lg {
      font-size: rem(16);
    }
  }

  .def-input {
    font-size: rem(14);
    @include point-md {
      font-size: rem(12);
    }
    @include point-lg {
      font-size: rem(14);
    }
  }
  .def-input[type='submit'] {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #28a37f;
    height: 50px;
    color: #fff;
    font-weight: 500;
    font-size: 1rem;
    padding: 0 30px;
    transition: 0.2s linear background-color;
    white-space: nowrap;
    overflow: hidden;
  }
  .hide-btn {
    background-color: lightgray;
    pointer-events: none;
    border: 2px solid transparent;
  }
  .def-button-border {
    width: 100%;
  }
}

//.enter-cabinet{
//    &__forgot-password{
//        display: inline;
//        height: auto;
//        margin-top: -8px;
//        align-self: flex-start;
//        margin-bottom: 12px;
//        color: #504949;
//        font-family: $font-sf;
//        font-size: rem(14);
//        @include point-md{
//            font-size: rem(12);
//        }
//        @include point-lg{
//            font-size: rem(14);
//            margin-bottom: 20px;
//        }
//    }
//}
</style>
